































































































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios from "axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { API_URL } from "../global";
import AddressCard from "@/components/AddressCard.vue";
import {
  TweenMax,
  TimelineLite,
  Power3,
  Power4,
  Power1,
  Power2,
  TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";
const DEFAULT_CONTACT_FORM = {
  name: "",
  // subject: "",
  email: "",
  phone: "",
  message: "",
  company: "",
  category: "",
};
@Component({
  name: "ContactFormCard",
  components: {
    AddressCard,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class ContactFormCard extends Vue {
  public contactform: any = JSON.parse(JSON.stringify(DEFAULT_CONTACT_FORM));
  submitted: boolean = false;
  submitSuccess: boolean = false;
  showform: boolean = false;

  companyData: any = [];
  contactCategoryData: any = [];

  @Watch("contactform.company", {
    immediate: true,
  })
  handleCompanyChange(val: any, oldVal: any) {
    if (val != oldVal) {
      // console.log("CHANGED");
      this.fetchContactCategory(val);
    }
  }

  fetchCompany() {
    axios
      .get(`${API_URL}/others/company/`)
      .then((resp: any) => {
        this.companyData = resp["data"];
        if (this.companyData.length > 0) {
          this.contactform.company = "";
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  fetchContactCategory(companyId: any) {
    axios
      .get(`${API_URL}/others/contact-category/?company=${companyId}`)
      .then((resp: any) => {
        this.contactCategoryData = resp["data"];
        if (this.contactCategoryData.length > 0) {
          // this.contactform.category = this.contactCategoryData[0].id;
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  resetForm() {
    this.contactform = JSON.parse(JSON.stringify(DEFAULT_CONTACT_FORM));
  }
  submitForm() {
    //   this.$validator.validate().then(valid => {
    //             if (valid) {
    axios
      .post(`${API_URL}/contact-form/`, this.contactform)
      .then((resp: any) => {
        this.submitted = true;
        this.submitSuccess = true;
      })
      .catch((err: any) => {
        this.submitted = true;
      });
    //     }
    // });
  }

  public formAnim() {
    const ft = new TimelineMax()
      .staggerFrom(
        ".sq-contact-form",
        0.6,
        {
          yPercent: 40,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.05
      )
      .staggerFrom(
        ".form-cont",
        0.6,
        {
          yPercent: 30,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.2"
      );

    const controller = new ScrollMagic.Controller();
    const scene = new ScrollMagic.Scene({
      triggerElement: ".sq-contact-form",
      // triggerHook: 0.5,
      triggerHook: "onEnter",
      reverse: false,
    })
      .setTween(ft)
      .addTo(controller);
  }
  public mounted() {
    this.fetchCompany();
    if (window.matchMedia("(min-width: 1025px)").matches) {
      this.formAnim();
    }
  }
}
